import React from "react";

import LogobarWrapper from "../../util/LogobarWrapper";

function HomeItem(props) {
    const { text } = props;

    return <LogobarWrapper isActive={true}>{text}</LogobarWrapper>;
}

export default HomeItem;
